export const LANDSCAPE_ORIENTATION = 'landscape';
export const PORTRAIT_ORIENTATION = 'portrait';

export const isOrientationLockAvailable = () => {
	const screen = window.screen;

	if (screen) {
		const orientation = screen.orientation;

		if (orientation) {
			const lock = orientation.lock;

			if (lock && typeof lock === 'function') {
				return true;
			}
		}
	}
	return false;
};


// WEBPACK FOOTER //
// ./src/functions/orientation.js